import React from 'react';
import clsx from 'clsx';
import { ChevronLeftIcon, ChevronRightIcon } from '@ag1/ui';
import styles from './styles.module.scss';
import { ReviewsSliderButtonsProps } from './types';

const ReviewsSliderButtons = ({
  onScrollPrev,
  onScrollNext,
  chevronColor = 'dark'
}: ReviewsSliderButtonsProps) => {
  const chevronClass = clsx(styles.button, {
    [styles.dark]: chevronColor === 'dark',
    [styles.light]: chevronColor === 'light'
  });

  return (
    <div className={styles.root}>
      <button
        type="button"
        className={chevronClass}
        onClick={onScrollPrev ? () => onScrollPrev() : undefined}
        disabled={!onScrollPrev}
        data-gtm-skip-global>
        <ChevronLeftIcon titleAccess="Previous" />
      </button>
      <button
        type="button"
        className={chevronClass}
        onClick={onScrollNext ? () => onScrollNext() : undefined}
        disabled={!onScrollNext}
        data-gtm-skip-global>
        <ChevronRightIcon titleAccess="Next" />
      </button>
    </div>
  );
};

export default ReviewsSliderButtons;
